// extracted by mini-css-extract-plugin
export default {"emojis":"Emoji_emojis__Qey58","emoji":"Emoji_emoji__UmQcg","duration":"Emoji_duration__2nqt9","isLiked":"Emoji_isLiked__+WE5a"};